<div class="account-address-wrapper">
  <address [address]="address"></address>
  <div class="account-address-buttons-container">
    <button box-button [size]="'small'" [theme]="'insignificant'" (click)="edit()">{{ 'edit_' | translate }}</button>
    <button
      box-button
      [size]="'small'"
      [theme]="'insignificant'"
      [borders]="'none'"
      (click)="delete()"
      class="account-address-delete-button"
    >
      {{ 'delete_' | translate }}
    </button>
  </div>
</div>
